import { type ThemeColor } from '@sites/site-theme/src/types';
import { type TranslateService } from '@ngx-translate/core';
import { getColorMap, getVarColor } from '@common/helpers/tiny-mce';

const defaultToolbarMenu =
    'EditWidget undo redo styleselect fontsizeselect pasteAsTextCustom pasteTextCustom clearTextStyleCustom bold italic forecolor backcolor TextGradient underline strikethrough link lists alignment code AIButton';

export const defaultTinymceConfig = (
    translateService: TranslateService,
    baseUrl: string = '/',
    isInline: boolean = true,
    selectedThemeColors: ThemeColor[] = [],
    toolbarMenu: string = '',
    isEdu: boolean = false,
    isPasteAsText: boolean = false
) => {
    const plugins = `lists code paste link`;
    const baseConfig: any = {
        base_url: `${baseUrl}assets/tinymce`,
        inline: isInline,
        suffix: '.min',
        menubar: false,
        plugins: plugins,
        paste_as_text: isPasteAsText,
        advlist_bullet_styles: 'circle',
        toolbar: !toolbarMenu ? defaultToolbarMenu : toolbarMenu,
        color_map: getColorMap(selectedThemeColors),
        contextmenu: false,
        formats: {
            forecolor: {
                inline: 'span',
                classes: 'forecolor',
                styles: {
                    color: (value) => getVarColor(value, (color?: any) => (color ? color : selectedThemeColors)),
                },
            },
        },
        color_cols: 5,
        toolbar_items_size: 'small',
        fontsize_formats:
            '8px 10px 12px 13px 14px 16px 18px 20px 24px 28px 32px 36px 42px 48px 54px 60px 66px 72px 78px 84px 90px 96px 112px 124px 144px 160px 178px 200px 225px 250px 275px 300px 350px 400px 450px 500px',
        placeholder: translateService.instant('editor_placeholder'),
        skin_url: `${baseUrl}assets/styles/tinymce/skins/ui/sp_lpc`,
    };

    if (isEdu) {
        baseConfig.block_formats = 'Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3;Heading 4=h4';
    } else {
        baseConfig.style_formats = [
            { title: translateService.instant('theme_settings_font_paragraph'), block: 'p', classes: 'paragraph' },
            { title: translateService.instant('theme_settings_font_heading_2'), block: 'h2' },
            { title: translateService.instant('theme_settings_font_heading_3'), block: 'h3' },
            { title: translateService.instant('theme_settings_font_heading_4'), block: 'h4' },
            { title: translateService.instant('theme_settings_font_leading'), block: 'p', classes: 'leading' },
            { title: translateService.instant('theme_settings_font_big'), block: 'p', classes: 'big' },
            { title: translateService.instant('theme_settings_font_quote'), block: 'p', classes: 'quote' },
            { title: translateService.instant('theme_settings_font_small'), block: 'p', classes: 'small' },
            { title: translateService.instant('theme_settings_font_signature'), block: 'p', classes: 'signature' },
            { title: translateService.instant('theme_settings_font_heading_1'), block: 'h1' },
        ];
    }

    return baseConfig;
};
